// Commons
import '@commons/reset';
import '@commons/components';
import '@commons/matrix';
import '@commons/utils';

// Layouts
import '@styles/layouts/l-sector-grid.scss';
import '@styles/layouts/l-sectors.scss';

// Components
import '@styles/components/c-sector.scss';
import '@styles/components/c-sector-tile.scss';
import '@styles/components/c-page-banner.scss';
import '@styles/components/c-map.scss';

const mapEl = document.querySelector('.js-map');
window.addEventListener('CookiebotOnAccept', () => {
  const hasCookieConsent = window.Cookiebot.consent.necessary && window.Cookiebot.consent.statistics
    && window.Cookiebot.consent.marketing && window.Cookiebot.consent.preferences;
  if (mapEl && hasCookieConsent) {
    mapEl.classList.remove('c-map--inactive');
    import('@modules/map')
      .then((module) => module.default())
      .catch(() => console.error('Could not load map module'));
  }
});
